/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirmwareType,
    FirmwareTypeFromJSON,
    FirmwareTypeFromJSONTyped,
    FirmwareTypeToJSON,
} from './FirmwareType';

/**
 * 
 * @export
 * @interface FirmwareResponse
 */
export interface FirmwareResponse {
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    id: string;
    /**
     * 
     * @type {FirmwareType}
     * @memberof FirmwareResponse
     */
    type: FirmwareType;
    /**
     * 
     * @type {Date}
     * @memberof FirmwareResponse
     */
    date: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    client: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    createdBy: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FirmwareResponse
     */
    createdAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    modifiedBy: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FirmwareResponse
     */
    modifiedAt: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FirmwareResponse
     */
    deviceTypes: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FirmwareResponse
     */
    deviceTypeIds: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    version: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    comment: string | null;
    /**
     * 
     * @type {number}
     * @memberof FirmwareResponse
     */
    fileVersion: number | null;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    name: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FirmwareResponse
     */
    appliedUpgradeRules: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    downloadUrl: string | null;
}

export function FirmwareResponseFromJSON(json: any): FirmwareResponse {
    return FirmwareResponseFromJSONTyped(json, false);
}

export function FirmwareResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwareResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': FirmwareTypeFromJSON(json['type']),
        'date': (json['date'] === null ? null : new Date(json['date'])),
        'client': json['client'],
        'createdBy': json['createdBy'],
        'createdAt': (json['createdAt'] === null ? null : new Date(json['createdAt'])),
        'modifiedBy': json['modifiedBy'],
        'modifiedAt': (json['modifiedAt'] === null ? null : new Date(json['modifiedAt'])),
        'deviceTypes': json['deviceTypes'],
        'deviceTypeIds': json['deviceTypeIds'],
        'version': json['version'],
        'comment': json['comment'],
        'fileVersion': json['fileVersion'],
        'name': json['name'],
        'appliedUpgradeRules': json['appliedUpgradeRules'],
        'downloadUrl': json['downloadUrl'],
    };
}

export function FirmwareResponseToJSON(value?: FirmwareResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': FirmwareTypeToJSON(value.type),
        'date': (value.date === null ? null : value.date.toISOString()),
        'client': value.client,
        'createdBy': value.createdBy,
        'createdAt': (value.createdAt === null ? null : value.createdAt.toISOString()),
        'modifiedBy': value.modifiedBy,
        'modifiedAt': (value.modifiedAt === null ? null : value.modifiedAt.toISOString()),
        'deviceTypes': value.deviceTypes,
        'deviceTypeIds': value.deviceTypeIds,
        'version': value.version,
        'comment': value.comment,
        'fileVersion': value.fileVersion,
        'name': value.name,
        'appliedUpgradeRules': value.appliedUpgradeRules,
        'downloadUrl': value.downloadUrl,
    };
}

